import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      /*
       * Odakta kenarlık RENGİ değişiyor ve içeriden bir tel ekleniyor —
       * kutu boyutu sabit kalıyor. Kenarlık kalınlığını artırmak, odaklanınca
       * alanın 1px büyümesine ve yanındaki alanların oynamasına yol açıyordu.
       */
      className={cn(
        'flex h-8.5 w-full rounded-[var(--radius-sm)] border border-border-strong bg-bg-elevated',
        'px-2.5 text-[0.8125rem] text-fg transition-[border-color,box-shadow] duration-150',
        'placeholder:text-fg-subtle',
        'focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/15',
        'disabled:cursor-not-allowed disabled:bg-bg-sunken disabled:opacity-60',
        'aria-[invalid=true]:border-danger aria-[invalid=true]:focus:ring-danger/15',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
